export type BobThinkingPhase = "idle" | "dissolving" | "swarm" | "reforming";

export type BobBandFrame = {
  solid: number;
  alpha: number;
  spread: number;
  progress: number;
};

export const restingBand = (): BobBandFrame => ({ solid: 1, alpha: 0, spread: 0, progress: 0 });
export const isRestingBand = (band: BobBandFrame) => band.progress === 0;

const clamp = (value: number) => Math.max(0, Math.min(1, value));
const smooth = (value: number) => {
  const x = clamp(value);
  return x * x * (3 - 2 * x);
};

/** Dissolve is exactly reassembly in reverse; reversing midway preserves every band. */
export function thinkingTransition(thinking: boolean, current: readonly BobBandFrame[]) {
  const duration = 1550 + Math.max(0, current.length - 1) * 65;
  const from = current[0]?.progress ?? 0;
  return (elapsed: number) => {
    const progress = clamp(from + ((thinking ? 1 : -1) * Math.max(0, elapsed)) / duration);
    const bands = current.map((_, index): BobBandFrame => {
      const gathering = clamp((duration * (1 - progress) - index * 65) / 1550);
      const solid = smooth((gathering - 0.68) / 0.3);
      return { solid, alpha: 1 - solid, spread: 1 - smooth(gathering / 0.83), progress };
    });
    const done = !thinking && progress === 0;
    const phase: BobThinkingPhase = thinking
      ? progress === 1
        ? "swarm"
        : "dissolving"
      : done
        ? "idle"
        : "reforming";
    return { bands, phase, done };
  };
}
